
import { mapGetters, mapMutations, mapActions } from 'vuex'
import bank from "@/apollo/queries/bank/bank";

export default {
	props: {
		pageTitle: String
	},
	data() {
		return {
			modalChooseCar: {
				component: 'modal-choose',
				visibility: true
			},
		}
	},

	computed: {
		...mapGetters({
			currentCar: 'modal/modal-choose/currentCar',
			totalSum: 'form/form-credit/totalSum',
			benefitsSlider_installment: 'benefits/benefitsSlider_installment',
			bank: 'banks/bank',

		}),

		// ...mapGetters({
		// 	site_id: 'site_id',

		// 	currentCar: 'modal/modal-choose/currentCar',
		// 	bank: 'banks/bank',
		// 	settings: 'settings/settings/settings',
		// 	activeModal: 'modal/modal-main/modal',
		// 	banks: 'banks/banks',

		// }),
		component() {
			return this.$device.isMobile ? 'catalog-item-minicard' : 'catalog-item-minicard'
		},
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal',

		}),
		...mapActions({
			request: 'filters/filters/request',
		}),
		chooseCar() {
			let payload = {
				modal_component: 'modal-choose',
				modal_title: 'Выберите автомобиль',
				modal_sub_title: '10 560 автомобилей в наличии'
			}
			this.openModal(payload)
		},
		...mapMutations({
			setPercent: 'banks/SET_PERCENT',
			// setCurrentCar: 'form/form-credit/SET_CURRENT_CAR',
			setFocusShowFixes: 'car/car/SET_FOCUS_SHOW_FIXED',
			setOffer: 'catalog/catalog-cars/SET_OFFER',
			setCurrentCar: 'modal/modal-choose/SET_CURRENT_CAR',

			setBanks: 'banks/SET_BANKS',
			setBank: 'banks/SET_BANK'


		}),
	},
	async fetch() {
		if (this.$route.params.bank) {
			try {
				let response = await this.request({ query: bank, variables: { slug: this.$route.params.bank } })
				await this.setBank(response.data.bank)
			} catch (error) {
				return this.$nuxt.error({ statusCode: 404, message: '404' })
			}
		}else{
			this.setBank({})
		}
	},

}
